import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-help-desk-experience }}\n{{yield}}",{ moduleName: "embercom/components/inbox2/adapters/workspace.hbs" })